import { createSlice } from '@reduxjs/toolkit';

const skillLevelSlice = createSlice({
  name: 'skillLevels',
  initialState: {
    skillLevels: [],
    dataValid: false
  },
  reducers: {
    setSkillLevels(state, action) {
      console.count("skillLevelSlice: setSkillLevels");
      if (!action || !action.payload || !action.payload.skillLevels) {
          state.skillLevels = [];
          state.dataValid = false;    
      } else {
        state.skillLevels = action.payload.skillLevels;
        state.dataValid = !!action.payload.dataValid;
      }
    },
    patchSkillLevels(state, action) {
      if (!action || !action.payload || !action.payload.skillLevels) {
        state.dataValid = false;
        return;
      }

      state.dataValid = !!action.payload.dataValid;

      if (!state.skillLevels) return;

      action.payload.skillLevels.forEach(updatedUserLevels => {
        if (!updatedUserLevels) return;
        if (!updatedUserLevels.userId) return;
        if (!updatedUserLevels.skillLevels) return;

        let userLevels = state.skillLevels.find(item => item.userId === updatedUserLevels.userId);

        if (!userLevels) {
          userLevels = {
            userId: updatedUserLevels.userId,
            skillLevels: []
          }

          state.skillLevels.push(userLevels);
        }

        if (!userLevels.skillLevels) {
          userLevels.skillLevels = [];
        }

        updatedUserLevels.skillLevels.forEach(updatedLevel => {
          let level = userLevels.skillLevels.find(item => item.id === updatedLevel.id);

          if (!level) {
            level = {
              id: updatedLevel.id,
              proficiency: updatedLevel.proficiency,
            }
          } else {
            level.proficiency = updatedLevel.proficiency;
          }

        });

      });
    },
    invalidateData(state, action) {
      state.dataValid = false;
    }
  },
});

export const skillLevelActions = skillLevelSlice.actions;

export default skillLevelSlice;